module.exports = __webpack_public_path__ + "static/media/assignment.43601c43.svg";